export default __webpack_public_path__ + "static/media/SJA1460.34I-42102_-25247_0.68403700.jpg";